module.exports = __webpack_public_path__ + "img/9788997581146.cb5a54b4.jpg";